import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  Input,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import LaunchIcon from '@mui/icons-material/Launch';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { infoIconStyle, cardTitle, infoIconButton } from 'src/App/Dashboards/Market/styles/style';
import {
  COLOR_ERROR_1,
  COLOR_PRIMARY_1,
  COLOR_PRIMARY_2,
  COLOR_SECONDARY_1,
  COLOR_SECONDARY_2,
  COLOR_SECONDARY_2_800,
  COLOR_SUCCESS_1,
  COLOR_TERTIARY_1_100,
  COLOR_WARNING,
  RED_BUTTON_COLOR,
} from 'src/colors';
import { callApi } from 'src/core/callApi';
import { InfoTooltip } from 'src/App/HOC/Tooltips';
import { COLOR_TOOLTIP_BACKGROUND } from 'src/const';
import { DataGrid, GridColDef, GridRow } from '@mui/x-data-grid';
import { ListViewData } from 'src/interfaces/idashboard';

const Kpi = ({ adminPassword }) => {
  const [showFullDataModal, setShowFullDataModal] = useState<boolean>(false);
  const [kpiData, setKpiData] = useState<any>();
  const [conversionRateData, setConversionRateData] = useState<any>();
  const [conversionRateOnWeeklyBasis, setConversionRateOnWeeklyBasis] = useState<any>([]);
  const [revenuePerRegistration, setRevenuePerRegistration] = useState<any>();
  const [revenuePerRegistrationOnWeeklyBasis, setRevenuePerRegistrationOnWeeklyBasis] = useState<any>();
  const [refundKpiData, setRefundKpiData] = useState<any>();
  const [refundKpiOnWeeklyBasis, setRefundKpiOnWeeklyBasis] = useState<any>([]);
  const [expandedKpiName, setExpandedKpiName] = useState<string>('Conversion Rate');
  const [infraCostRawdata, setInfraCostRawdata] = useState<any>();
  const [infraCostdata, setInfraCostdata] = useState<any>();
  const [showInfraCostLoader, setShowInfraCostLoader] = useState<boolean>(false);
  const [past7daysInfraCostdata, setPast7daysInfraCostdata] = useState<any>();
  const [avgAwsCost, setAvgAwsCost] = useState<any>();
  const [showGetInfraCostButton, setShowGetInfraCostButton] = useState<boolean>(true);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [marketingData, setMarketingData] = useState<any>();
  const [past7DaysOrganicUserData, setPast7DaysOrganicUserData] = useState<any>();
  const [avgOrganicUsers, setAvgOrganicUsers] = useState<any>();
  const [avgPSeoSignups, setAvgPSeoSignups] = useState<number>(0);
  const [avgPSeoClicks, setAvgPSeoClicks] = useState<number>(0);
  const [subscriptionRateData, setsubscriptionRateData] = useState<any>([]);
  const [searchHitRatesData, setsearchHitRatesData] = useState<any>([]);
  const [avgSearchHitRatesWeeklyData, SetAvgSearchHitRatesWeeklyData] = useState<any>([]);
  const [bugHitRateData, SetBugHitRateData] = useState<any>([]);
  const [avgBugHitRateWeeklyData, setAvgBugHitRateWeeklyData] = useState<any>([]);
  const [individualListingDiscoveryRateData, SetIndividualListingDiscoveryRateData] = useState<any>(
    []
  );
  const [
    avgIndividualListingDiscoveryRateWeeklyData,
    SetAvgIndividualListingDiscoveryRateWeeklyData,
  ] = useState<any>([]);
  const [dynamicDataUpdateAttemptRatesData, setDynamicDataUpdateAttemptRatesData] = useState<any>(
    []
  );
  const [
    avgDynamicDataUpdateAttemptRateWeeklyData,
    setAvgDynamicDataUpdateAttemptRateWeeklyData,
  ] = useState<any>([]);
  const [showSubscriptionBy, setShowSubscriptionBy] = useState<string>('signups');
  const [gcpAndBrightPricingData, setGcpAndBrightPricingData] = useState<any>();
  const [affiliatePartnerEmailID, setAffiliatePartnerEmailID] = useState<string>('');
  const [affiliatePartnerName, setAffiliatePartnerName] = useState<string>('');
  const [affiliatePartnerKey, setAffiliatePartnerKey] = useState<string>('');
  const [showEmailOrNameMissingAlert, setShowEmailOrNameMissingAlert] = useState<boolean>(false);
  const [showAffiliateKeyLoader, setShowAffiliateKeyLoader] = useState<boolean>(false);
  const [programmaticSeoKpi, setProgrammaticSeoKpi] = useState<any>();
  // console.log("showGetInfraCostButton>>",showGetInfraCostButton)

  useEffect(() => {
    fetchKpiDetails();
    fetchSubscribersRate();
    fetchSearchRate();
    fetchBugRate();
    fetchProgramaticSeoKpi();
  }, []);

  useEffect(() => {
    formatUserKpiData(kpiData?.userData, kpiData?.marketingData);
    // formatInfraCostData(kpiData?.infra_cost);
    // formatMarketingData(kpiData?.marketingData);
  }, [showSubscriptionBy]);

  useEffect(() => {
    formatInfraCostData(infraCostRawdata);
  }, [infraCostRawdata]);

  useEffect(() => {
    formatUserKpiData(kpiData?.userData, kpiData?.marketingData);
    formatMarketingData(kpiData?.marketingData);
  }, [kpiData, subscriptionRateData]);

  const listViewColsForGcpAndBrightPricingdata: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 200, hide: true },
    {
      field: 'service',
      headerName: 'Service',
      flex: 1.4,
      editable: false,
    },
    {
      field: 'period',
      headerName: 'Time Period',
      flex: 1.4,
      editable: false,
    },
    {
      field: 'cost',
      headerName: 'Cost in $',
      flex: 1.4,
      editable: false,
    },
  ];

  const fetchApi = async (url, queryParams, retry = 0) => {
    if (retry > 5) return null;
    try {
      const res = await callApi(url, { queryParams }, false);
      const resString = JSON.stringify(res);
      if (resString == '{}') {
        throw new Error('Timeout');
      }
      return res;
    } catch (err) {
      console.log('Error: ', err);
      fetchApi(url, queryParams, retry + 1);
    }
  };

  const fetchProgramaticSeoKpi = async () => {
    const url =
      'https://xig1why4m3.execute-api.us-east-2.amazonaws.com/default/getProgrammaticSeoKPIs';
    const data = await callApi(url, {}, false);
    const pSeoDataArray: { date: string; signups: number; clicks: number }[] = [];
    let avgPSeoSignups: number = 0;
    let avgPSeoClicks: number = 0;
    try {
      if (data.message) {
        for (const entry of data.message) {
          pSeoDataArray.push({
            date: entry.date,
            signups: entry.seo_signups,
            clicks: entry.total_clicks,
          });
          avgPSeoSignups += entry.seo_signups ? entry.seo_signups : 0;
          avgPSeoClicks += entry.total_clicks ? entry.total_clicks : 0;
        }
        setProgrammaticSeoKpi(pSeoDataArray);
        pSeoDataArray.length && setAvgPSeoSignups(avgPSeoSignups / pSeoDataArray.length);
        pSeoDataArray.length && setAvgPSeoClicks(avgPSeoClicks / pSeoDataArray.length);
      }
    } catch (err) {
      console.log('Error getting programmatic seo data: ', err);
    }
  };

  const getDataGridRowsForGCPAndBrightPricingData = () => {
    // console.log("gcpAndBrightPricingData",gcpAndBrightPricingData)
    let rows: any[] = [];
    let id = 0;
    if (gcpAndBrightPricingData) {
      for (let date in gcpAndBrightPricingData['Bright pricing']) {
        rows.push({
          id: id,
          service: 'Bright pricing',
          period: date,
          cost: gcpAndBrightPricingData['Bright pricing'][date],
        });
        id += 1;
      }
      for (let date in gcpAndBrightPricingData['GCP']) {
        rows.push({
          id: id,
          service: 'GCP',
          period: date,
          cost: gcpAndBrightPricingData['GCP'][date],
        });
        id += 1;
      }
    }
    return rows;
  };

  let listViewDataForGcpAndBrightPricingdata: ListViewData[] = getDataGridRowsForGCPAndBrightPricingData();

  const handleSubscriptionByChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    setShowSubscriptionBy(value);
  };

  const fetchInfraCost = async () => {
    setShowInfraCostLoader(true);
    const URL =
      'https://brdbb9oa63.execute-api.us-east-2.amazonaws.com/default/getAirbticsInfraCost';
    const queryParams = {
      admin_password: encodeURIComponent(adminPassword),
    };

    const res = await callApi(URL, { queryParams }, false);
    setInfraCostRawdata(res);
    setGcpAndBrightPricingData(res.gcp_bright_pricing_data);
    setShowInfraCostLoader(false);
  };

  const fetchKpiDetails = async () => {
    setShowLoader(true);

    let currentDate = new Date();
    let dataPromises: any = [];

    for (let i = 1; i <= 10; i++) {
      let startDate = new Date(currentDate);
      let startFormattedDate = currentDate.toISOString().slice(0, 10);

      const url = 'https://31vyuq785c.execute-api.us-east-2.amazonaws.com/default/getKpiDetails';
      const queryParams = {
        admin_password: encodeURIComponent(adminPassword),
        startDate: startFormattedDate,
      };
      const fetchedRes = fetchApi(url, queryParams);
      dataPromises.push(fetchedRes);

      startDate.setDate(currentDate.getDate() - 7);
      currentDate = startDate;
    }

    const res = await Promise.all(dataPromises);
    let userData: any[] = [];
    let marketingData: any[] = [];

    for (let data of res) {
      userData = [...userData, ...data['user_data_date_wise']];
      marketingData = [...marketingData, ...data['merketing_data_date_wise']];
    }
    userData = userData.slice(0, 70);
    marketingData = marketingData.slice(0, 70);

    setKpiData({ userData: userData, marketingData: marketingData });
    setShowLoader(false);
  };

  const fetchSubscribersRate = async () => {
    let currentDate = new Date();
    let dataPromises: any = [];

    for (let i = 1; i <= 10; i++) {
      let startDate = new Date(currentDate);
      startDate.setDate(currentDate.getDate() - 7 * (i * 1));
      const startDateFormat = startDate.toISOString().split('T')[0];

      let endDate = new Date(currentDate);
      endDate.setDate(currentDate.getDate() - 7 * ((i - 1) * 1));
      const endDateFormat = endDate.toISOString().split('T')[0];

      const url =
        'https://c6y0kwvxcd.execute-api.us-east-2.amazonaws.com/default/getSubscribersRate';
      const queryParams = {
        admin_password: encodeURIComponent(adminPassword),
        startDate: startDateFormat,
        endDate: endDateFormat,
      };

      dataPromises.push(fetchApi(url, queryParams));
    }

    const dataByWeek = await Promise.all(dataPromises);

    let subscriptionRatedatadict = {};
    for (let weeklyData of dataByWeek) {
      let data = weeklyData['SubscriptionRate'];
      for (const date in data) {
        if (!subscriptionRatedatadict[date]) {
          subscriptionRatedatadict[date] = data[date];
        }
      }
    }
    setsubscriptionRateData(subscriptionRatedatadict);
  };

  const getPastFormattedDate = noOfDaysBack => {
    const currentDate = new Date();

    // Calculate the date by subtracting the specified number of days
    const targetDate = new Date(currentDate);
    targetDate.setDate(currentDate.getDate() - noOfDaysBack);

    // Get the year, month, and day components
    const year = targetDate.getFullYear();
    const month = String(targetDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(targetDate.getDate()).padStart(2, '0');

    // Format the date as 'YYYY-MM-DD'
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  };

  const fetchSearchRate = async () => {
    let dataPromises: any = [];

    for (let i = 0; i < 35; i++) {
      let date = getPastFormattedDate(i * 2);
      // console.log("date -->", date);

      const URL = 'https://enr4chqzbd.execute-api.us-east-2.amazonaws.com/default/getSearchHitRate';
      const queryParams = {
        admin_password: encodeURIComponent(adminPassword),
        date: date,
      };
      dataPromises.push(fetchApi(URL, queryParams));
    }
    const res = await Promise.all(dataPromises);
    let searchHitRates: any = [];
    let individualListingDiscoveryRate: any = [];
    let dynamicDataUpdateAttemptRates: any = [];
    for (const data of res) {
      let rates = data['search_hit_rates'];
      for (const date in rates) {
        searchHitRates.push({ date: date, rate: rates[date] });
      }

      let discoveryRates = data['individual_listing_discovery_rates'];
      for (const date in discoveryRates) {
        individualListingDiscoveryRate.push({ date: date, rate: discoveryRates[date] });
      }

      let dynamicDataUpdateAttemptRatesFromAPI = data['dynamic_data_update_attempt_rates'];
      for (const date in discoveryRates) {
        dynamicDataUpdateAttemptRates.push({
          date: date,
          rate: dynamicDataUpdateAttemptRatesFromAPI[date],
        });
      }
    }

    let avgSearchHitRatesOnWeeklyBasis = getGraphDataOnWeeklyBasis(searchHitRates);
    let avgIndividualListingDiscoveryRatesOnWeeklyBasis = getGraphDataOnWeeklyBasis(
      individualListingDiscoveryRate
    );
    let dynamicDataUpdateAttemptRatesOnWeeklyBasis = getGraphDataOnWeeklyBasis(
      dynamicDataUpdateAttemptRates
    );
    searchHitRates = searchHitRates.reverse();
    individualListingDiscoveryRate = individualListingDiscoveryRate.reverse();
    dynamicDataUpdateAttemptRates = dynamicDataUpdateAttemptRates.reverse();

    setsearchHitRatesData(searchHitRates);
    SetAvgSearchHitRatesWeeklyData(avgSearchHitRatesOnWeeklyBasis);
    SetIndividualListingDiscoveryRateData(individualListingDiscoveryRate);
    SetAvgIndividualListingDiscoveryRateWeeklyData(avgIndividualListingDiscoveryRatesOnWeeklyBasis);
    setDynamicDataUpdateAttemptRatesData(dynamicDataUpdateAttemptRates);
    setAvgDynamicDataUpdateAttemptRateWeeklyData(dynamicDataUpdateAttemptRatesOnWeeklyBasis);
  };

  const fetchBugRate = async () => {
    let dataPromises: any = [];

    for (let i = 1; i < 71; i += 2) {
      let date = getPastFormattedDate(i);
      // console.log("date -->", date);

      const URL =
        'https://9jt4k17j1m.execute-api.us-east-2.amazonaws.com/default/getAirbticsBugRate';
      const queryParams = {
        admin_password: encodeURIComponent(adminPassword),
        date: date,
      };
      dataPromises.push(fetchApi(URL, queryParams));
    }
    const res = await Promise.all(dataPromises);
    // console.log('res =>', res);

    let bugHitRate: any = [];
    for (const data of res) {
      let rates = data['Bug_rates'];
      for (const date in rates) {
        bugHitRate.push({ date: date, rate: rates[date] });
      }
    }

    let avgBugHitRatesOnWeeklyBasis = getGraphDataOnWeeklyBasis(bugHitRate);
    bugHitRate = bugHitRate.reverse();
    // console.log('bugHitRate>>', bugHitRate);
    // console.log('avgBugHitRatesOnWeeklyBasis>>', avgBugHitRatesOnWeeklyBasis);
    SetBugHitRateData(bugHitRate);
    setAvgBugHitRateWeeklyData(avgBugHitRatesOnWeeklyBasis);
  };

  const formatInfraCostData = infraCostRawData => {
    let formattedInfraCostData: any = [];
    if (infraCostRawData?.aws_cost) {
      setShowGetInfraCostButton(false);
      for (const date in infraCostRawData.aws_cost) {
        formattedInfraCostData.push({
          date: date,
          awsCost: infraCostRawData.aws_cost[date]['aws'],
        });
      }
    }
    setInfraCostdata(formattedInfraCostData);
    setPast7daysInfraCostdata(formattedInfraCostData.slice(-7));
    setAvgAwsCost(avgLastWeekStats(formattedInfraCostData.slice(-7), 'awsCost'));
  };

  const formatMarketingData = marketingRawData => {
    let marketingGraphData: any[] = [];

    if (marketingRawData) {
      const marketingData = marketingRawData.reduce((acc, obj) => {
        const [key, value] = Object.entries(obj)[0];
        acc[key] = value;
        return acc;
      }, {});

      for (let date in marketingData) {
        marketingGraphData.push({
          date: date,
          sessions: marketingData[date]['sessions'],
          organicSessions: marketingData[date]['organic_sessions'],
        });
      }
      marketingGraphData = marketingGraphData.reverse();
      marketingGraphData = marketingGraphData.slice(0, -1);
      let marketingGraphDataFor7Days = marketingGraphData.slice(-7);

      let past7DaysTotalOrganicSessions = 0;
      for (let data of marketingGraphDataFor7Days) {
        past7DaysTotalOrganicSessions += +data['organicSessions'];
      }
      let past7DaysAvgOrganicSessions = (past7DaysTotalOrganicSessions / 7).toFixed(1);

      setMarketingData(marketingGraphData);
      setPast7DaysOrganicUserData(marketingGraphDataFor7Days);
      setAvgOrganicUsers(past7DaysAvgOrganicSessions);
    }
  };

  const formatUserKpiData = (UserRawData, marketingRawData) => {
    let completeKpiData: any[] = [];
    let mainKpiGraphData: any[] = [];
    let refundKpiData: any[] = [];
    let revenuePerRegistration: any[] =[];

    if (subscriptionRateData && UserRawData && marketingRawData) {
      const marketingData = marketingRawData.reduce((acc, obj) => {
        const [key, value] = Object.entries(obj)[0];
        acc[key] = value;
        return acc;
      }, {});

      for (const data of UserRawData) {
        let date = data['date'];
        let organicSessions = marketingData[date]?.organic_sessions || 0;
        let sessions = marketingData[date]?.sessions || 0;
        let subscribedUsers = subscriptionRateData[date]?.subscribed_count || 0;
        let revenue = subscriptionRateData[date]?.revenue || 0

        data['data']['subscribed_count'] = subscribedUsers;
        data['data']['organic_sessions'] = organicSessions;
        data['data']['sessions'] = sessions;
        data['data']['revenue'] = revenue;
        completeKpiData.push(data);
      }

      // console.log(">>>>>completeKpiData",completeKpiData)

      for (const data of completeKpiData) {
        let conversionRate: any = 0;
        let revenuePerRegistrationRate: any = 0;

        if (showSubscriptionBy == 'signups' && data['data']['signup_count']) {
          conversionRate = (
            (data['data']['subscribed_count'] / data['data']['signup_count']) *
            100
          ).toFixed(1);
          // console.log(data['date'], data['data']['subscribed_count'],data['data']['signup_count']," CONVERSION ", conversionRate)
        }

        if (showSubscriptionBy == 'totalVisitors' && data['data']['sessions']) {
          conversionRate = (
            (data['data']['subscribed_count'] / data['data']['sessions']) *
            100
          ).toFixed(1);
        }

        if (showSubscriptionBy == 'organicVisitors' && data['data']['organic_sessions']) {
          conversionRate = (
            (data['data']['subscribed_count'] / data['data']['organic_sessions']) *
            100
          ).toFixed(1);
        }

        if (showSubscriptionBy == 'verifiedUsers' && data['data']['verified_count']) {
          conversionRate = (
            (data['data']['subscribed_count'] / data['data']['verified_count']) *
            100
          ).toFixed(1);
        }

        if (showSubscriptionBy == 'refunds' && data['data']['refund_count']) {
          conversionRate = (
            (data['data']['subscribed_count'] / data['data']['refund_count']) *
            100
          ).toFixed(1);
        }

        if (showSubscriptionBy == 'totalSubscription') {
          conversionRate = data['data']['subscribed_count'];
        }

        // console.log("----",data['data']['revenue'] , data['data']['signup_count'] , data['date'])
        if(data['data']['signup_count']){
          revenuePerRegistrationRate = (data['data']['revenue']/data['data']['signup_count']).toFixed(1);
        }

        mainKpiGraphData.push({ date: data['date'], rate: conversionRate });
        refundKpiData.push({ date: data['date'], refund: data['data']['refund_count'] });
        revenuePerRegistration.push({ date: data['date'], rate: revenuePerRegistrationRate });
      }

      // console.log(">>>>>revenuePerRegistration",revenuePerRegistration)
      let mainKpiGraphDataOnWeeklyBasis = getGraphDataOnWeeklyBasis(mainKpiGraphData);
      let revenuePerRegistrationOnWeeklyBasis = getGraphDataOnWeeklyBasis(revenuePerRegistration);
      let refundKpiDataOnWeeklyBasis = getRefundKpiGraphDataOnWeeklyBasis(refundKpiData);
      mainKpiGraphData = mainKpiGraphData.reverse();
      refundKpiData = refundKpiData.reverse();
      revenuePerRegistration = revenuePerRegistration.reverse();

      setConversionRateData(mainKpiGraphData);
      setConversionRateOnWeeklyBasis(mainKpiGraphDataOnWeeklyBasis);
      setRefundKpiData(refundKpiData);
      setRefundKpiOnWeeklyBasis(refundKpiDataOnWeeklyBasis);
      setRevenuePerRegistration(revenuePerRegistration)
      setRevenuePerRegistrationOnWeeklyBasis(revenuePerRegistrationOnWeeklyBasis)
    }
  };

  const getRefundKpiGraphDataOnWeeklyBasis = refundKpiData => {
    const batchSize = 7;
    const refundKpiDataBatches: any = [];
    let refundKpiDataOnWeeklyBasis: any = [];

    for (let i = 0; i < refundKpiData.length; i += batchSize) {
      const batch = refundKpiData.slice(i, i + batchSize);
      refundKpiDataBatches.push(batch);
    }

    for (let i = 0; i < 10; i++) {
      let totalWeeklyRefund = 0;
      for (let data of refundKpiDataBatches[i]) {
        totalWeeklyRefund += +data['refund'];
      }
      refundKpiDataOnWeeklyBasis.push({
        week: `Preceding Week ${i + 1}`,
        refunds: totalWeeklyRefund,
      });
    }
    refundKpiDataOnWeeklyBasis = refundKpiDataOnWeeklyBasis.reverse();

    return refundKpiDataOnWeeklyBasis;
  };

  const getGraphDataOnWeeklyBasis = mainKpiGraphData => {
    const batchSize = 7;
    const mainKpidataBatches: any = [];
    let mainKpiGraphDataOnWeeklyBasis: any = [];

    for (let i = 0; i < mainKpiGraphData.length; i += batchSize) {
      const batch = mainKpiGraphData.slice(i, i + batchSize);
      mainKpidataBatches.push(batch);
    }
    for (let i = 0; i < 10; i++) {
      let totalWeeklyConversionRate = 0;
      for (let data of mainKpidataBatches[i]) {
        totalWeeklyConversionRate += +data['rate'];
      }
      let weeklyConversionRate = (totalWeeklyConversionRate / 7).toFixed(1);

      mainKpiGraphDataOnWeeklyBasis.push({
        week: `Preceding Week ${i + 1}`,
        rate: weeklyConversionRate,
      });
    }
    mainKpiGraphDataOnWeeklyBasis = mainKpiGraphDataOnWeeklyBasis.reverse();

    return mainKpiGraphDataOnWeeklyBasis;
  };

  const avgLastWeekStats = (past7DaysData, key) => {
    let total = 0;
    for (const data of past7DaysData) {
      total += +data[key];
    }
    let avg = total / 7;
    return avg.toFixed(1);
  };

  const FullDataModal = () => {
    const datasetMapping = {
      'Conversion Rate': {
        dataVariableName: conversionRateData,
        barKeyName: 'rate',
        barColor: '#82ca9d',
      },
      'Refund Rate': {
        dataVariableName: refundKpiData,
        barKeyName: 'refund',
        barColor: RED_BUTTON_COLOR,
      },
      'Infra Cost': {
        dataVariableName: infraCostdata,
        barKeyName: 'awsCost',
        barColor: '#82ca9d',
      },
      'Orgainc Signups': {
        dataVariableName: marketingData,
        barKeyName: 'organicSessions',
        barColor: '#82ca9d',
      },
      'Search Hit Rates': {
        dataVariableName: searchHitRatesData,
        barKeyName: 'rate',
        barColor: '#82ca9d',
      },
      'Bug Hit Rates': {
        dataVariableName: bugHitRateData,
        barKeyName: 'rate',
        barColor: '#82ca9d',
      },
      'Individual Listing Discovery Rates': {
        dataVariableName: individualListingDiscoveryRateData,
        barKeyName: 'rate',
        barColor: '#82ca9d',
      },
      'Dynamic Data Update Attempt Rates': {
        dataVariableName: dynamicDataUpdateAttemptRatesData,
        barKeyName: 'rate',
        barColor: '#82ca9d',
      },
      'Revenue Per Registrations':{
        dataVariableName: revenuePerRegistration,
        barKeyName: 'rate',
        barColor: '#82ca9d',
      }
    };
    return (
      <Modal
        open={showFullDataModal}
        onClose={() => {
          setShowFullDataModal(!showFullDataModal);
        }}
      >
        <Box
          sx={{
            width: '80vw',
            height: '70vh',
            background: '#121212',
            border: '1px solid white',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '30px',
            borderRadius: 4,
          }}
        >
          <Box
            sx={{
              height: '100px',
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h4" sx={{ color: 'white', fontWeight: '500' }}>
              {expandedKpiName} Past {expandedKpiName == 'Infra Cost' ? '4' : '10'} Weeks Data
            </Typography>
            {expandedKpiName == 'Conversion Rate' && (
              <Box
                sx={{
                  height: '27px',
                }}
              >
                <FormControl
                  variant="standard"
                  size="small"
                  sx={{
                    width: 200,
                    padding: '0px',
                    backgroundColor: 'white',
                  }}
                >
                  <Select
                    labelId="subscription-by-select"
                    id="subscription-by-select"
                    value={`${showSubscriptionBy}`}
                    onChange={handleSubscriptionByChange}
                    label="Subscription By"
                  >
                    <MenuItem value={'signups'}>By Signups</MenuItem>
                    <MenuItem value={'verifiedUsers'}>By Verified Users</MenuItem>
                    <MenuItem value={'totalVisitors'}>By Total Visitors</MenuItem>
                    <MenuItem value={'organicVisitors'}>By Organic Visitors</MenuItem>
                    <MenuItem value={'refunds'}>By Refunds</MenuItem>
                    <MenuItem value={'totalSubscription'}>Total Subscriptions</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
          </Box>
          <Box sx={{ width: '100%', display: 'flex' }}>
            <ResponsiveContainer
              height={400}
              width={expandedKpiName == 'Infra Cost' ? '50%' : '100%'}
            >
              <BarChart
                width="100%"
                height="100%"
                data={datasetMapping[expandedKpiName]['dataVariableName']}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} />
                <Bar
                  dataKey={datasetMapping[expandedKpiName]['barKeyName']}
                  stackId="a"
                  fill={datasetMapping[expandedKpiName]['barColor']}
                />
              </BarChart>
            </ResponsiveContainer>
            {expandedKpiName == 'Infra Cost' && (
              <div style={{ height: '400px', width: '50%' }}>
                <DataGrid
                  sortingOrder={['desc']}
                  sx={{ backgroundColor: 'white' }}
                  rows={listViewDataForGcpAndBrightPricingdata}
                  columns={listViewColsForGcpAndBrightPricingdata}
                  disableColumnFilter={true}
                  disableColumnMenu={true}
                  // initialState={{
                  //   sorting: {
                  //     sortModel: [{ field: 'avgRevenue', sort: 'desc' }],
                  //   },
                  // }}
                />
              </div>
            )}
          </Box>
        </Box>
      </Modal>
    );
  };

  const handleAffiliatePartnerAccountCreation = async () => {
    setShowAffiliateKeyLoader(true);
    setShowEmailOrNameMissingAlert(false);
    const url =
      'https://a8q9o0b2r3.execute-api.us-east-2.amazonaws.com/default/createAffiliatePartner';
    const config = {
      queryParams: {
        admin_password: encodeURIComponent(adminPassword),
        name: affiliatePartnerName,
        email: encodeURIComponent(affiliatePartnerEmailID),
      },
    };
    if (affiliatePartnerName && affiliatePartnerEmailID) {
      const res = await callApi(url, config, false);
      setAffiliatePartnerKey(res.partnerKey);
      setShowEmailOrNameMissingAlert(false);
      setShowAffiliateKeyLoader(false);
    } else {
      setShowEmailOrNameMissingAlert(true);
      setShowAffiliateKeyLoader(false);
    }
  };

  return (
    <Box
      sx={{
        height: '95%',
        width: '100%',
        margin: '10px',
        overflowY: 'scroll',
      }}
    >
      <FullDataModal />
      {!showLoader && (
        <Box sx={{ display: 'flex', gap: 5, flexDirection: 'column', height: '100%' }}>
          {/* BUSINESS KPI */}
          <Box>
            <Box sx={{ textAlign: 'center', margin: '10px' }}>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: '600' }}>
                Business KPIs
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 5, padding: '10px' }}>
              {/* Conversion Rate */}
              <Box
                sx={{
                  height: '550px',
                  width: '450px',
                  backgroundColor: '#121212',
                }}
              >
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <InfoTooltip
                    title={
                      <Card>
                        <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                          <Grid container direction="column" alignItems="flex-start">
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              In this chart, we are displaying the daily percentage of Subscribed
                              per Verified Users. To generate this graph, we require two components:
                              Verified Users, obtained from our DynamoDB user table, and Subscribed
                              Users, fetched from the Stripe API.
                            </Typography>
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              Note: Subscribed users may also include individuals who signed up more
                              than 28 days ago.
                            </Typography>
                          </Grid>
                        </CardContent>
                      </Card>
                    }
                    enterTouchDelay={0}
                    leaveTouchDelay={10000}
                  >
                    <IconButton style={infoIconButton}>
                      <InfoOutlinedIcon style={infoIconStyle} />
                    </IconButton>
                  </InfoTooltip>
                  <Button
                    onClick={() => {
                      setShowFullDataModal(true);
                      setExpandedKpiName('Conversion Rate');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '100px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    Subscription conversion rate (PRIMARY KPI)
                  </Typography>
                  <Box
                    sx={{
                      height: '27px',
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <FormControl
                      variant="standard"
                      size="small"
                      sx={{
                        width: 200,
                        padding: '0px',
                        backgroundColor: 'white',
                      }}
                    >
                      <Select
                        labelId="subscription-by-select"
                        id="subscription-by-select"
                        value={`${showSubscriptionBy}`}
                        onChange={handleSubscriptionByChange}
                        label="Subscription By"
                      >
                        <MenuItem value={'signups'}>By Signups</MenuItem>
                        <MenuItem value={'verifiedUsers'}>By Verified Users</MenuItem>
                        <MenuItem value={'totalVisitors'}>By Total Visitors</MenuItem>
                        <MenuItem value={'organicVisitors'}>By Organic Visitors</MenuItem>
                        <MenuItem value={'refunds'}>By Refunds</MenuItem>
                        <MenuItem value={'totalSubscription'}>Total Subscriptions</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={conversionRateOnWeeklyBasis}
                  margin={{ top: 20, right: 30, left: 20, bottom: 55 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="week"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    tick={{ fontSize: 10 }} // Set the font size here
                  />
                  <YAxis />
                  <Tooltip />
                  {/* <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} /> */}
                  <Bar dataKey="rate" stackId="a" fill={COLOR_PRIMARY_1} />
                </BarChart>
              </Box>

              {/* Refund Vs Subscribed Users */}
              <Box
                sx={{
                  height: '550px',
                  width: '450px',
                  backgroundColor: '#121212',
                }}
              >
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <InfoTooltip
                    title={
                      <Card>
                        <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                          <Grid container direction="column" alignItems="flex-start">
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              In this chart, we depict the daily percentage of refunds compared to
                              the number of subscribed users. To generate this graph, we need two
                              things: subscribed users and the daily count of refunds, So we
                              retrieve both things from the Stripe API.
                            </Typography>
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              Note: Subscribed users may also include individuals who signed up more
                              than 28 days ago.
                              <br />
                              In the Stripe Dashboard, refunds are displayed based on the
                              subscription creation date. However, in this graph, refunds are
                              represented on the day they actually occur.
                            </Typography>
                          </Grid>
                        </CardContent>
                      </Card>
                    }
                    enterTouchDelay={0}
                    leaveTouchDelay={10000}
                  >
                    <IconButton style={infoIconButton}>
                      <InfoOutlinedIcon style={infoIconStyle} />
                    </IconButton>
                  </InfoTooltip>
                  <Button
                    onClick={() => {
                      setShowFullDataModal(true);
                      setExpandedKpiName('Refund Rate');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '100px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    Refunds
                  </Typography>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={refundKpiOnWeeklyBasis}
                  margin={{ top: 20, right: 30, left: 20, bottom: 55 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="week"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    tick={{ fontSize: 10 }}
                  />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="refunds" stackId="a" fill={RED_BUTTON_COLOR} />
                </BarChart>
              </Box>

              {/* INFRA */}
              <Box sx={{ height: '550px', width: '450px', backgroundColor: '#121212' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <InfoTooltip
                    title={
                      <Card>
                        <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                          <Grid container direction="column" alignItems="flex-start">
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              In this chart, we are displaying the daily infrastructure costs. To
                              generate this chart, we require two components: the daily AWS cost and
                              the daily GCP cost. We currently fetch the AWS daily cost from the AWS
                              Cost Explorer API and retrieve data for GCP from the GCP API.
                            </Typography>
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              Note: The daily AWS cost is the sum of AWS costs from the Airbtics
                              Account and AWS costs from the Furnibnb Account.
                              <br />
                              We are currently not fetching GCP costs, so the displayed value for
                              that is 0.
                            </Typography>
                          </Grid>
                        </CardContent>
                      </Card>
                    }
                    enterTouchDelay={0}
                    leaveTouchDelay={10000}
                  >
                    <IconButton style={infoIconButton}>
                      <InfoOutlinedIcon style={infoIconStyle} />
                    </IconButton>
                  </InfoTooltip>
                  <Button
                    onClick={() => {
                      setShowFullDataModal(true);
                      setExpandedKpiName('Infra Cost');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '100px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    Infra Cost
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ color: 'white', width: '100%', textAlign: 'center' }}
                  >
                    Avg Infra Cost: $<span style={{ color: COLOR_ERROR_1 }}>{avgAwsCost}</span>
                  </Typography>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={past7daysInfraCostdata}
                  margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} />
                  <Bar dataKey="awsCost" stackId="a" fill={COLOR_SECONDARY_2_800} />
                  <Bar dataKey="gcp" stackId="a" fill="#82ca9d" />
                </BarChart>
                {showGetInfraCostButton && (
                  <Box
                    sx={{
                      height: '390px',
                      width: '400px',
                      position: 'relative',
                      top: '-372px',
                      backgroundColor: '#ccc1',
                      left: '27px',
                      backdropFilter: 'blur(3px)',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {showInfraCostLoader && <CircularProgress />}
                    <Button
                      sx={{
                        backgroundColor: '#037A90',
                        '&:hover': { backgroundColor: '#037A90' },
                        color: 'white',
                      }}
                      onClick={fetchInfraCost}
                    >
                      {' '}
                      Get AWS Cost
                    </Button>
                    <Alert severity="warning">Every time you get this data it costs.</Alert>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>

          {/* REVENUE KPI */}
          <Box>
            <Box sx={{ textAlign: 'center', margin: '10px' }}>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: '600' }}>
                Revenue KPIs
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 5, padding: '10px' }}>
              {/* Conversion Rate */}
              <Box
                sx={{
                  height: '550px',
                  width: '450px',
                  backgroundColor: '#121212',
                }}
              >
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <InfoTooltip
                    title={
                      <Card>
                        <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                          <Grid container direction="column" alignItems="flex-start">
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              New revenue per registration" is used to measure the average amount of
                              revenue generated per new user registration. The new revenue should
                              include new sales only from the plans available on the pricing page
                              currently.
                            </Typography>
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              New revenue per registration = Total new revenue / Total number of
                              registrations
                            </Typography>
                          </Grid>
                        </CardContent>
                      </Card>
                    }
                    enterTouchDelay={0}
                    leaveTouchDelay={10000}
                  >
                    <IconButton style={infoIconButton}>
                      <InfoOutlinedIcon style={infoIconStyle} />
                    </IconButton>
                  </InfoTooltip>
                  <Button
                    onClick={() => {
                      setShowFullDataModal(true);
                      setExpandedKpiName('Revenue Per Registrations');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '100px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    New revenue per registration
                  </Typography>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={revenuePerRegistrationOnWeeklyBasis}
                  margin={{ top: 20, right: 30, left: 20, bottom: 55 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="week"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    tick={{ fontSize: 10 }} // Set the font size here
                  />
                  <YAxis />
                  <Tooltip />
                  {/* <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} /> */}
                  <Bar dataKey="rate" stackId="a" fill={COLOR_PRIMARY_1} />
                </BarChart>
              </Box>
            </Box>
          </Box>

          {/* PRODUCT KPI */}
          <Box>
            <Box sx={{ textAlign: 'center', margin: '10px' }}>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: '600' }}>
                Product KPIs
              </Typography>
            </Box>
            <Grid container direction="row" sx={{ display: 'flex', gap: 4, padding: '10px' }}>
              {/* search Hit Rate */}
              <Box sx={{ height: '550px', width: '450px', backgroundColor: '#121212' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <InfoTooltip
                    title={
                      <Card>
                        <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                          <Grid container direction="column" alignItems="flex-start">
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              This Chart will display the Rearch Hit Rate and this data is fetched
                              from DynamoDB.
                            </Typography>
                          </Grid>
                        </CardContent>
                      </Card>
                    }
                    enterTouchDelay={0}
                    leaveTouchDelay={10000}
                  >
                    <IconButton style={infoIconButton}>
                      <InfoOutlinedIcon style={infoIconStyle} />
                    </IconButton>
                  </InfoTooltip>
                  <Button
                    onClick={() => {
                      setShowFullDataModal(true);
                      setExpandedKpiName('Search Hit Rates');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '70px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    Search Hit Rates in (%)
                  </Typography>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={avgSearchHitRatesWeeklyData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 55 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="week"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    tick={{ fontSize: 10 }}
                  />
                  <YAxis />
                  <Tooltip />
                  {/* <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} /> */}
                  <Bar dataKey="rate" stackId="a" fill={COLOR_SUCCESS_1} />
                </BarChart>
              </Box>

              {/* Bug Hit Rate */}
              <Box sx={{ height: '550px', width: '450px', backgroundColor: '#121212' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <InfoTooltip
                    title={
                      <Card>
                        <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                          <Grid container direction="column" alignItems="flex-start">
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              This Chart will display the Bug Hit Rate and this data is fetched from
                              RDS.
                            </Typography>
                          </Grid>
                        </CardContent>
                      </Card>
                    }
                    enterTouchDelay={0}
                    leaveTouchDelay={10000}
                  >
                    <IconButton style={infoIconButton}>
                      <InfoOutlinedIcon style={infoIconStyle} />
                    </IconButton>
                  </InfoTooltip>
                  <Button
                    onClick={() => {
                      setShowFullDataModal(true);
                      setExpandedKpiName('Bug Hit Rates');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '70px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    Bug Hit Rates in (%)
                  </Typography>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={avgBugHitRateWeeklyData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 55 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="week"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    tick={{ fontSize: 10 }}
                  />
                  <YAxis />
                  <Tooltip />
                  {/* <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} /> */}
                  <Bar dataKey="rate" stackId="a" fill={RED_BUTTON_COLOR} />
                </BarChart>
              </Box>

              {/* Individual Listing Discovery Rate */}
              <Box sx={{ height: '550px', width: '450px', backgroundColor: '#121212' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <InfoTooltip
                    title={
                      <Card>
                        <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                          <Grid container direction="column" alignItems="flex-start">
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              This Chart will display the Individual Listing Discovery Rate and this
                              data is fetched from DynamoDB.
                            </Typography>
                          </Grid>
                        </CardContent>
                      </Card>
                    }
                    enterTouchDelay={0}
                    leaveTouchDelay={10000}
                  >
                    <IconButton style={infoIconButton}>
                      <InfoOutlinedIcon style={infoIconStyle} />
                    </IconButton>
                  </InfoTooltip>
                  <Button
                    onClick={() => {
                      setShowFullDataModal(true);
                      setExpandedKpiName('Individual Listing Discovery Rates');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '70px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    Individual Listing Discovery Rate in (%)
                  </Typography>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={avgIndividualListingDiscoveryRateWeeklyData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 55 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="week"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    tick={{ fontSize: 10 }}
                  />
                  <YAxis />
                  <Tooltip />
                  {/* <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} /> */}
                  <Bar dataKey="rate" stackId="a" fill="#8884d8" />
                </BarChart>
              </Box>

              {/* Dynamic Data Update Attempt Rate */}
              <Box sx={{ height: '550px', width: '450px', backgroundColor: '#121212' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <InfoTooltip
                    title={
                      <Card>
                        <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                          <Grid container direction="column" alignItems="flex-start">
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              This Chart will display the Dynamic Data Update Attempt Rate and this
                              data is fetched from DynamoDB.
                            </Typography>
                          </Grid>
                        </CardContent>
                      </Card>
                    }
                    enterTouchDelay={0}
                    leaveTouchDelay={10000}
                  >
                    <IconButton style={infoIconButton}>
                      <InfoOutlinedIcon style={infoIconStyle} />
                    </IconButton>
                  </InfoTooltip>
                  <Button
                    onClick={() => {
                      setShowFullDataModal(true);
                      setExpandedKpiName('Dynamic Data Update Attempt Rates');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '70px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    Dynamic Data Update Attempt Rate in (%)
                  </Typography>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={avgDynamicDataUpdateAttemptRateWeeklyData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 55 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="week"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    tick={{ fontSize: 10 }}
                  />
                  <YAxis />
                  <Tooltip />
                  {/* <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} /> */}
                  <Bar dataKey="rate" stackId="a" fill={COLOR_WARNING} />
                </BarChart>
              </Box>
            </Grid>
          </Box>

          {/* MARKETING KPI */}
          <Box>
            {/* MARKETING */}
            <Box sx={{ textAlign: 'center', margin: '10px' }}>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: '600' }}>
                Marketing KPIs
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 5, padding: '10px' }}>
              {/* Organic Signups */}
              <Box sx={{ height: '550px', width: '450px', backgroundColor: '#121212' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <InfoTooltip
                    title={
                      <Card>
                        <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                          <Grid container direction="column" alignItems="flex-start">
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              This chart displays daily organic user data obtained from Google
                              Analytics. The graph requires the count of daily organic users, which
                              is fetched from Google Analytics.
                            </Typography>
                          </Grid>
                        </CardContent>
                      </Card>
                    }
                    enterTouchDelay={0}
                    leaveTouchDelay={10000}
                  >
                    <IconButton style={infoIconButton}>
                      <InfoOutlinedIcon style={infoIconStyle} />
                    </IconButton>
                  </InfoTooltip>
                  <Button
                    onClick={() => {
                      setShowFullDataModal(true);
                      setExpandedKpiName('Orgainc Signups');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '100px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    Organic Signups
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ color: 'white', width: '100%', textAlign: 'center' }}
                  >
                    Avg Organic Signups:{' '}
                    <span style={{ color: COLOR_SUCCESS_1 }}>{avgOrganicUsers}</span>
                  </Typography>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={past7DaysOrganicUserData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} />
                  <Bar dataKey="organicSessions" stackId="a" fill="#8884d8" />
                </BarChart>
              </Box>

              {/* Affiliate Partner Onboarding */}
              <Box sx={{ height: '550px', width: '450px', backgroundColor: '#121212' }}>
                <Box
                  sx={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography variant="h6" sx={{ color: '#ffff' }}>
                    Onboard Affiliate Partners
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      gap: 2,
                    }}
                  >
                    <Typography>Name:</Typography>
                    <TextField
                      id="outlined-basic"
                      label=""
                      variant="outlined"
                      size="small"
                      value={affiliatePartnerName}
                      onChange={e => {
                        setAffiliatePartnerName(e.target.value);
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: '#ffffff',
                        },
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      gap: 2,
                    }}
                  >
                    <Typography>Email:</Typography>
                    <TextField
                      id="outlined-basic"
                      label=""
                      variant="outlined"
                      size="small"
                      value={affiliatePartnerEmailID}
                      onChange={e => {
                        setAffiliatePartnerEmailID(e.target.value);
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: '#ffffff',
                        },
                      }}
                    />
                  </Box>
                  <Button
                    sx={{
                      backgroundColor: COLOR_PRIMARY_1,
                      cursor: 'pointer',
                      color: '#ffff',
                      '&:hover': { backgroundColor: COLOR_PRIMARY_2 },
                    }}
                    onClick={handleAffiliatePartnerAccountCreation}
                  >
                    Create Affiliate Account
                  </Button>

                  {showEmailOrNameMissingAlert && (
                    <Alert severity="error">Please enter name and email Id.</Alert>
                  )}

                  {affiliatePartnerKey && (
                    <Alert severity="success">Generated Key is {affiliatePartnerKey}</Alert>
                  )}

                  {showAffiliateKeyLoader && <CircularProgress />}
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Programmatic SEO KPIs */}
          <Box>
            <Box sx={{ textAlign: 'center', margin: '10px' }}>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: '600' }}>
                Programmatic SEO KPIs
              </Typography>
            </Box>

            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-start',
                gap: '20px',
                direction: 'row',
              }}
            >
              {/* P SEO Signups */}
              <Box sx={{ height: '550px', width: '450px', backgroundColor: '#121212' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    onClick={() => {
                      // setShowFullDataModal(true);
                      // setExpandedKpiName('Programmatic SEO Signups');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '100px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    Programmatic SEO Signups
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ color: 'white', width: '100%', textAlign: 'center' }}
                  >
                    Avg Programmatic SEO Signups:{' '}
                    <span style={{ color: COLOR_SUCCESS_1 }}>{avgPSeoSignups}</span>
                  </Typography>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={programmaticSeoKpi}
                  margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} />
                  <Bar dataKey="signups" stackId="a" fill="#8884d8" />
                </BarChart>
              </Box>

              {/* P SEO Clicks */}
              <Box sx={{ height: '550px', width: '450px', backgroundColor: '#121212' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    onClick={() => {
                      // setShowFullDataModal(true);
                      // setExpandedKpiName('Programmatic SEO Signups');
                    }}
                  >
                    <LaunchIcon />
                  </Button>
                </Box>
                <Box sx={{ height: '100px', padding: '10px' }}>
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    Programmatic SEO Clicks
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ color: 'white', width: '100%', textAlign: 'center' }}
                  >
                    Avg Programmatic SEO Clicks:{' '}
                    <span style={{ color: COLOR_SUCCESS_1 }}>{avgPSeoClicks}</span>
                  </Typography>
                </Box>
                <BarChart
                  width={400}
                  height={300}
                  data={programmaticSeoKpi}
                  margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'white' }} />
                  <Bar dataKey="clicks" stackId="a" fill="#ff7700" />
                </BarChart>
              </Box>
            </Box>
          </Box>

          {/* Usefull Resources */}
          <Box>
            <Box sx={{ textAlign: 'center', margin: '10px' }}>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: '600' }}>
                Usefull Resources
              </Typography>
            </Box>
            <Box
              sx={{
                width: '95%',
                // backgroundColor: '#121212',
                padding: '20px',
              }}
            >
              <Box sx={{ display: 'flex', gap: 2, marginBottom: '10px' }}>
                <Typography variant="h6" sx={{ color: 'white' }}>
                  See All KPIs At Airbtics :
                </Typography>
                <Button
                  onClick={() => {
                    window.open(
                      'https://www.notion.so/airbtics/KPIs-be29b7cc247648e9ac51fe11175bc181',
                      '_blank'
                    );
                  }}
                  sx={{ backgroundColor: COLOR_TERTIARY_1_100 }}
                >
                  Airbtics KPIs
                </Button>
              </Box>
              <Box sx={{ display: 'flex', gap: 2, marginBottom: '10px' }}>
                <Typography variant="h6" sx={{ color: 'white' }}>
                  See Survey Results :
                </Typography>
                <Button
                  onClick={() => {
                    window.open(
                      'https://insights.hotjar.com/sites/1926311/surveys/responses/968108?sort_by=-index',
                      '_blank'
                    );
                  }}
                  sx={{ backgroundColor: COLOR_TERTIARY_1_100 }}
                >
                  Survey Results
                </Button>
              </Box>
              <Box sx={{ display: 'flex', gap: 2, marginBottom: '10px' }}>
                <Typography variant="h6" sx={{ color: 'white' }}>
                  Stripe Dashboard :
                </Typography>
                <Button
                  onClick={() => {
                    window.open('https://dashboard.stripe.com/dashboard', '_blank');
                  }}
                  sx={{ backgroundColor: COLOR_TERTIARY_1_100 }}
                >
                  Stripe
                </Button>
              </Box>
              <Box sx={{ display: 'flex', gap: 2, marginBottom: '10px' }}>
                <Typography variant="h6" sx={{ color: 'white' }}>
                  Google Analytics Dashboard :
                </Typography>
                <Button
                  onClick={() => {
                    window.open(
                      'https://analytics.google.com/analytics/web/#/p379520711/reports/reportinghub?params=_u..nav%3Dmaui',
                      '_blank'
                    );
                  }}
                  sx={{ backgroundColor: COLOR_TERTIARY_1_100 }}
                >
                  Stripe
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {showLoader && (
        <Box
          sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

export default Kpi;
